export function initProductDetailsHero(root = document) {
    root.querySelectorAll('.product-details-hero:not([data-pdh-bound])').forEach(function (hero) {
        hero.dataset.pdhBound = 'true';

        var thumbs = hero.querySelectorAll('.thumb');
        var images = hero.querySelectorAll('.main-img');
        var dots = hero.querySelectorAll('.img-dot');
        var copyButton = hero.querySelector('[data-copy-link]');

        function activateImage(index) {
            thumbs.forEach(function (thumb) {
                thumb.classList.toggle('is-active', thumb.getAttribute('data-index') === index);
            });

            images.forEach(function (image) {
                image.classList.toggle('is-active', image.getAttribute('data-index') === index);
            });

            dots.forEach(function (dot) {
                dot.classList.toggle('is-active', dot.getAttribute('data-index') === index);
            });
        }

        thumbs.forEach(function (thumb) {
            thumb.addEventListener('click', function () {
                activateImage(thumb.getAttribute('data-index'));
            });
        });

        dots.forEach(function (dot) {
            dot.addEventListener('click', function () {
                activateImage(dot.getAttribute('data-index'));
            });
        });

        if (copyButton) {
            copyButton.addEventListener('click', function () {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(window.location.href);
                }
            });
        }
    });
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        initProductDetailsHero();
    });
} else {
    initProductDetailsHero();
}
